var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg41(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 135.47 135.47",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0444 0 0 1.0444 -3.204 -171.71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.221 176.09v66.222c0 9.4651 9.3645 22.539 18.943 28.972l26.082 17.517 25.813-17.517c9.5475-6.4791 18.943-19.507 18.943-28.972v-66.222c-29.665-8.7742-59.61-8.1596-89.78 0z",
    fill: "#265ab1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.924 186.24v55.775c0 7.972 10.945 19.391 15.955 24.402v-56.446l14.748 13.274v23.597h14.212v-23.597l14.748-13.274v56.446c5.0103-5.0103 15.955-16.43 15.955-24.402v-55.775h-15.151l-22.658 21.586-22.659-21.586z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.924 183.6v55.775c0 7.972 10.945 19.391 15.955 24.402v-56.446l14.748 13.274v23.597h14.212v-23.597l14.748-13.274v56.446c5.0103-5.0103 15.955-16.43 15.955-24.402v-55.775h-15.151l-22.658 21.586-22.659-21.586z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 0 161.53)",
    d: "m256.72 31.008c-56.563 0.29037-113.37 8.5802-170.38 24v10c114.03-30.84 227.21-33.163 339.33 0v-10c-56.06-16.581-112.38-24.29-168.95-24z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 0 161.53)",
    d: "m86.336 295.29v10c0 35.774 35.393 85.186 71.596 109.5l98.576 66.205 97.561-66.205c36.085-24.488 71.596-73.726 71.596-109.5v-10c0 35.774-35.511 85.012-71.596 109.5l-97.561 66.205-98.576-66.205c-36.202-24.314-71.596-73.726-71.596-109.5z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.923 169.74c-0.01826 1e-4 -0.03652 4.2e-4 -0.05478 5.2e-4v119.06l25.812-17.517c9.5475-6.4791 18.943-19.506 18.943-28.971v-66.222c-14.832-4.3871-29.735-6.4268-44.701-6.35z",
    opacity: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg41);
export default __webpack_public_path__ + "static/media/41.3675999c4e0a5b259e5c3b83fa283df0.svg";
export { ForwardRef as ReactComponent };